import React, { useEffect } from 'react'
import { jwtDecode } from "jwt-decode"
import config from 'config'
import { useAuthDispatch,useAuthState } from 'context/AuthContext'
import { onGoogleLoginSuccess } from 'context/AuthContext/middleware'
import { getSessionStorageItem,useSetState } from 'utils'
// import { enableLogout } from '../../utils/login'

var jwtToken = ""
const GoogleSignInNew = () => {

    const dispatch = useAuthDispatch();
    const { authState } = useAuthState();

    const employee = getSessionStorageItem({ item: 'employee' });
    const user = getSessionStorageItem({ item: 'user' });

    const handleCredentialResponse = (response: any) => {
        jwtToken = response.credential
        const userDetails: any = jwtDecode(jwtToken)
        onGoogleLoginSuccess(userDetails, jwtToken, dispatch)
    }

    const initiateGoogleLogin = () => {
        const windowObj: any = window
        const googleClientId: any = config.clientId
        windowObj.google.accounts.id.initialize({
            client_id: googleClientId,
            callback: handleCredentialResponse,
            auto_complete: true,
            itp_support: true,
        });
        windowObj.google.accounts.id.renderButton(
            document.getElementById("buttonDiv"),
            { theme: "outline", size: "large" }  // customization attributes
        );
        windowObj.google.accounts.id.prompt(); // also display the One Tap dialog

    }

    useEffect(() => {
        if (!(employee && user)) {
            initiateGoogleLogin()
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    // useEffect(() => {
    //     if(enableLogout(authState)){
    //         console.log(authState)
    //         initialiseGoogleLogout(dispatch)
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [])



    return (
        <div id="buttonDiv" className='googleBtn'></div>
    )
}
export default GoogleSignInNew